export default __webpack_public_path__ + "static/media/maximise_Icon.1d7b6d11.svg";